// Copyright (c) 2018 Deere & Company

import ExcelLayout from '@deere/cps-it.warranty-model-factory/lib/excel-layout';
import t from 'tcomb';

const ExcelLayouts = t.list(ExcelLayout, 'ExcelLayouts');

export const getDefaultState = () =>
    new ExcelLayouts([]);

export default ExcelLayouts;



// WEBPACK FOOTER //
// ./src/shared/state/excel-layouts.js